import React from 'react';

export interface XoeMedLogoProps {
  /** Overall lockup height in px; width scales with the wordmark. */
  height?: number;
  className?: string;
}

/**
 * XoeMedLogo — the Xoe Med brand lockup.
 *
 * Wordmark "Xoe Med" with the Xoe sparkle accent. Purely presentational:
 * colour is inherited via `currentColor` (adapts to light/dark), the sparkle
 * uses the brand primary token, and all sizing derives from `height`.
 */
const XoeMedLogo: React.FC<XoeMedLogoProps> = ({ height = 34, className }) => (
  <span
    className={className}
    role="img"
    aria-label="Xoe Med"
    style={{
      display: 'inline-flex',
      alignItems: 'baseline',
      gap: '0.16em',
      fontFamily: 'var(--mg-font-sans)',
      fontSize: height,
      lineHeight: 1,
      color: 'currentColor',
      letterSpacing: '-0.02em',
      userSelect: 'none',
    }}
  >
    <span style={{ position: 'relative', fontWeight: 700 }}>
      Xoe
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        width={height * 0.32}
        height={height * 0.32}
        style={{ position: 'absolute', top: '-0.30em', right: '-0.46em', color: 'var(--mg-primary)' }}
      >
        <path
          fill="currentColor"
          d="M12 0C12 6.6 6.6 12 0 12C6.6 12 12 17.4 12 24C12 17.4 17.4 12 24 12C17.4 12 12 6.6 12 0Z"
        />
      </svg>
    </span>
    <span style={{ fontWeight: 400, opacity: 0.66 }}>Med</span>
  </span>
);

export default XoeMedLogo;
